import { Outlet, useMatches } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { Sheet, SheetContent } from "@/design";
import { AskGuvPanel } from "./AskGuv";
import { CommandPalette } from "./CommandPalette";
import { useProjectSlug } from "./context";
import { Shortcuts } from "./Shortcuts";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";

/** Authenticated layout: sidebar, top bar, command palette, Ask Guv, shortcuts. Screens render in <Outlet />. */
export function AppShell() {
  const [mobileNav, setMobileNav] = useState(false);
  useDocumentTitle();
  return (
    <div className="flex min-h-dvh">
      <a href="#main" className="sr-only z-50 rounded-md bg-surface px-3 py-2 focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:shadow-lg">
        Skip to content
      </a>
      <aside className="sticky top-0 hidden h-dvh w-[252px] shrink-0 border-r border-border bg-sidebar lg:block">
        <Sidebar />
      </aside>
      <Sheet open={mobileNav} onOpenChange={setMobileNav}>
        <SheetContent side="left" size="sm" title="Menu" className="bg-sidebar [&>div:first-child]:hidden [&>div:nth-child(2)]:p-0">
          <Sidebar onNavigate={() => setMobileNav(false)} />
        </SheetContent>
      </Sheet>
      <div className="flex min-w-0 flex-1 flex-col">
        <TopBar onMenu={() => setMobileNav(true)} />
        <main id="main" className="flex-1" tabIndex={-1}>
          <Outlet />
        </main>
      </div>
      <CommandPalette />
      <AskGuvPanel />
      <Shortcuts />
    </div>
  );
}

function useDocumentTitle() {
  const matches = useMatches();
  const project = useProjectSlug();
  const title = [...matches].reverse().find((m) => m.staticData?.title)?.staticData.title;
  useEffect(() => {
    document.title = [title, project, "Guv"].filter(Boolean).join(" · ");
  }, [title, project]);
}
